import { useEffect } from "react";
import { Button, Col, Form, Input, Row, Space, Typography } from "antd";

import { useNavigate } from "react-router-dom";

import { checkTokenValidity } from "../../helper/auth";
import Notification from "../../components/Notification";
import authenticationService from "../../api/authentication";
import "./login.css";
import dataLogin from "./auth";

const Login = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      const params = { ...values };
      const res = await authenticationService.login(params);

      if (res.status == 200) {
        Notification("success", "Đăng nhập thành công");
        dataLogin(res);
        navigate("/danh-sach-hop-dong");
      } else {
        Notification("error", "Tài khoản hoặc mật khẩu không chính xác");
      }
    } catch (error) {
      Notification("error", "Tài khoản hoặc mật khẩu không chính xác");
    }
  };
  return (
    <div className="login">
      <Form
        form={form}
        layout="vertical"
        requiredMark={false}
        onFinish={onFinish}
      >
        <Space
          style={{ width: "100%" }}
          direction="vertical"
          align="center"
          size={"small"}
        >
          <Row>
            <h1>HỆ THỐNG QUẢN LÝ HỢP ĐỒNG SEC</h1>
          </Row>
          <Form.Item
            name="username"
            rules={[
              { required: true, message: "Vui lòng nhập tên đăng nhập!" },
            ]}
          >
            <Input placeholder="Tên đăng nhập" />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: "Vui lòng nhập mật khẩu!" }]}
          >
            <Input.Password placeholder="Mật khẩu" />
          </Form.Item>

          <Row>
            <Button
              type="primary"
              className="login-btn btn-sub"
              htmlType="submit"
            >
              Đăng nhập
            </Button>
          </Row>
        </Space>
      </Form>
    </div>
  );
};

export default Login;
